import React, { useState, useEffect } from 'react';
import { FastField as FormikField } from 'formik';
import { FormRow, FormColumn } from '@xo-union/tk-component-form-grid';
import SectionHeader from '../SectionHeader';
import { FocusOn } from '../interfaces';
import ContactFields from './ContactFields';
import Location from './Location';

interface ContactInfoProp {
  leaderIndex: number;
  displayFullAddress: boolean;
  focusOn: FocusOn;
}

const ContactInfo: React.FC<ContactInfoProp> = ({ leaderIndex, displayFullAddress, focusOn }) => {
  const [shouldDisplayFullAddress, setShouldDisplayFullAddress] = useState(displayFullAddress);
  const onPlaceSelect = (): void => {
    setShouldDisplayFullAddress(false);
  };

  const [detailsExpanded, setDetailsExpanded] = useState(false);

  const toggleExpanded = (): void => {
    setDetailsExpanded(!detailsExpanded);
  };

  useEffect(() => {
    if (focusOn === FocusOn.all && !detailsExpanded) {
      setDetailsExpanded(!detailsExpanded);
    }
  }, [focusOn, setDetailsExpanded, detailsExpanded]);

  return (
    <>
      <SectionHeader>Contact Information</SectionHeader>
      {shouldDisplayFullAddress ? (
        <FormRow>
          <FormColumn md>
            <FormikField
              data-testid="address.fullAddress"
              name="address.fullAddress"
              label="Full Address"
              component={Location}
              onPlaceSelect={onPlaceSelect}
            />
          </FormColumn>
        </FormRow>
      ) : (
        <ContactFields
          detailsExpanded={detailsExpanded}
          toggleExpanded={toggleExpanded}
          leaderIndex={leaderIndex}
          focusOn={focusOn}
        />
      )}
    </>
  );
};

export default ContactInfo;
